import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 13v-6l-5 4l-5 -4v6l5 4l5 -4","key":"svg-0"}]]

const IconArrowBadgeDown = createReactComponent('outline', 'arrow-badge-down', 'ArrowBadgeDown', __iconNode);

export default IconArrowBadgeDown;